import { Location } from "./types";

export const replaceHash = (location: Location) => {
  if (typeof window !== "undefined") {
    window.history.replaceState(
      "",
      document.title,
      window.location.pathname + `#${location}`,
    );
  }
};

export const removeHash = () => {
  if (typeof window !== "undefined") {
    window.history.replaceState("", document.title, window.location.pathname);
  }
};
